import React from 'react';
import { Navigate, Routes, Route } from 'react-router-dom';
import { nestedRoutes } from '../app/nestedRoutes';

const Main = () => {
  return (
    <Routes>
      {nestedRoutes.map(({ path, component, ...rest }) => (
        <Route key={path} path={path} element={component} {...rest} />
      ))}
      <Route path="/" element={<Navigate to="inbound" replace />} />
    </Routes>
  );
};

export default Main;
